import { render, staticRenderFns } from "./DaftarPustaka.vue?vue&type=template&id=500ae218&"
import script from "./DaftarPustaka.vue?vue&type=script&lang=js&"
export * from "./DaftarPustaka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports